import { useMutation } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { createUsdCreditsCheckout } from '../subscription.service';
/**
 * Mutation hook for creating a USD credits checkout session
 */
export function useCreateUsdCreditsCheckout() {
    const domain = getSubdomain();
    return useMutation({
        mutationFn: ({ amount }) => createUsdCreditsCheckout(domain, amount),
    });
}
